import PropTypes from "prop-types";
import { useEffect } from "react";
import useToast from "../../../../hooks/userToast";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import apiClient from "../../../../utils/apiClient";

// Define Yup schema
const schema = Yup.object().shape({
  name: Yup.string().required("Name required"),
  description: Yup.string().required("Description required"),
});

MasterAdd.propTypes = {
  fetchData: PropTypes.func,
  handleOk: PropTypes.func,
  Addurl: PropTypes.string,
  name: PropTypes.string,
};

function MasterAdd({ fetchData, handleOk, Addurl }) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const newEndpoint = Addurl === "/centers" ? "centers" : `${Addurl}/create`;
  const { toastError, toastSuccess } = useToast();

  const handlePost = async (values) => {
    try {
      const baseData = {
        name: values.name,
        description: values.description,
      };

      await apiClient.post(`${newEndpoint}`, baseData);
      toastSuccess("Added Successfully!");
      fetchData();
      handleOk();
      reset(); // Reset form fields
    } catch (err) {
      console.error(err?.response?.data);
      toastError(err?.response?.data?.error);
    }
  };

  useEffect(() => {
    reset(); // Reset form fields on initial load
    console.log("reset fields works");
  }, [reset]);

  return (
    <div className="new_custom_css">
      <div className="content">
        <div className="main-wrapper login-body">
          <div className="container-fluid px-0">
            <div className="row">
              <div className="col-lg-12">
                <div className="login-wrapper">
                  <div className="loginbox">
                    <div className="form_label">
                      <div className="login-right-wrap">
                        <form
                          onSubmit={handleSubmit(handlePost)}
                          className="row"
                        >
                          <div className="form-group d-flex flex-column">
                            <label>
                              Name <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              {...register("name")}
                            />
                            {errors.name && (
                              <p className="error-message login-danger">
                                {errors.name.message}
                              </p>
                            )}
                          </div>

                          <div className="form-group d-flex flex-column text_area">
                            <label>
                              Description{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <textarea
                              className="form-control"
                              {...register("description")}
                            />
                            {errors.description && (
                              <p className="error-message login-danger ">
                                {errors.description.message}
                              </p>
                            )}
                          </div>

                          <div className="form-group login-btn d-flex gap-5 justify-content-center new_type_register">
                            <button
                              className="btn btn-primary btn-block w-25"
                              type="submit"
                            >
                              Submit
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MasterAdd;
